import React from 'react';
import useInView from '../../hooks/useInView';
import FoundersHouse from './FoundersHouse';
import './OurStory.css';

const OurStory = () => {
  const { ref, inView } = useInView({ threshold: 0.1 });

  return (
    <section
      ref={ref}
      className={`our-story${inView ? ' our-story--visible' : ''}`}
    >
      <div className="our-story__container">
        <div className="our-story__divider" />

        <div className="our-story__grid">
          {/* Left — eyebrow + headline */}
          <div className="our-story__left">
            <p className="our-story__eyebrow">Our Story</p>
            <h2 className="our-story__headline">
              Two Students.
              <br />
              One Bad Landlord.
              <br />
              <span className="our-story__headline--accent">One Big Idea.</span>
            </h2>
            <FoundersHouse />
          </div>

          {/* Right — story body */}
          <div className="our-story__right">
            <p className="our-story__body">
              After graduating from Carnegie Mellon, we thought the hard part was behind us. 
              We’d survived a top university and landed our first real jobs.
              What we didn't expect was that when we moved out of our first apartment, 
              our landlord would walk away with thousands of dollars of our security 
              deposit — and that there was almost nothing we could do about it.
            </p>
            <p className="our-story__body">
              We felt completely helpless. Like most renters in that situation, we let it go. 
              But we couldn't stop thinking about it. We started talking to friends, classmates, people early
              in their careers — and we heard the same story over and over again.
              First-time renters, young professionals, people stretching every dollar,
              all losing pieces of their deposits to landlords who knew that inexperienced
              renters rarely push back.
            </p>
            <div className="our-story__punchline">
              <p className="our-story__punchline-text">
                We realized this wasn't bad luck. It was a pattern. And it was happening
                because there was no tool in the world built specifically to protect the
                person signing the lease.{' '}
                <span className="our-story__punchline--accent">So we built it.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
